export const DAY_LIST_REQUEST = 'DAY_LIST_REQUEST'
export const DAY_LIST_SUCCESS = 'DAY_LIST_SUCCESS'
export const DAY_LIST_FAIL = 'DAY_LIST_FAIL'

export const DAY_DETAILS_REQUEST = 'DAY_DETAILS_REQUEST'
export const DAY_DETAILS_SUCCESS = 'DAY_DETAILS_SUCCESS'
export const DAY_DETAILS_FAIL = 'DAY_DETAILS_FAIL'

export const DAY_UPDATE_REQUEST = 'DAY_UPDATE_REQUEST'
export const DAY_UPDATE_SUCCESS = 'DAY_UPDATE_SUCCESS'
export const DAY_UPDATE_FAIL = 'DAY_UPDATE_FAIL'
export const DAY_UPDATE_RESET = 'DAY_UPDATE_RESET'

export const DAY_VIDEO_LIST_REQUEST = 'DAY_VIDEO_LIST_REQUEST'
export const DAY_VIDEO_LIST_SUCCESS = 'DAY_VIDEO_LIST_SUCCESS'
export const DAY_VIDEO_LIST_FAIL = 'DAY_VIDEO_LIST_FAIL'
